import { AbstractStore } from "../common/AbstractStores";
import { ClienteDto } from "../generated";
import Dispatcher from "../common/dispatcher";
import { InLocalStorage } from "../common/InLocalStorage";
import CustomersActions, { CustomersFilterData } from "./customersActions";

class CustomersPageStore extends AbstractStore<ClienteDto> {
    private filter = new InLocalStorage<CustomersFilterData>("CustomersPageFilter")
    public getFilter = () => this.filter.get();
    constructor() {
        super(x => x.idCliente.toString(), new InLocalStorage("CustomersPageDAta"));
        Dispatcher
            .onfunction(CustomersActions.getCliente, result => result && this.updateIfNeeded(result))
            .onfunction(CustomersActions.submitFilter, ({ filter, result }) => {
                this.filter.set(filter);
                this.setAll(result);
            })
            .onfunction(CustomersActions.add, result => this.updateIfNeeded(result))
            .onfunction(CustomersActions.update, result => this.updateIfNeeded(result))
            .onfunction(CustomersActions.delete, result => {
                if (result.deleteOk)
                    this.delete(result.customerId.toString())
            })
    }

    updateIfNeeded(item: ClienteDto): void {
        const oldItem = this._storage.get();
        if (oldItem == null)
            return;

        var id = this.idSelector(item);
        if (!id)
            throw "invalid item";
        // if (this._storage.get() ![id] == undefined)
        //     throw "item not found";
        if (oldItem[id]) {
            oldItem[id] = item;
            this._storage.save();
            this.Changed.emit();
        }
    }
}

class CustomersStore extends AbstractStore<ClienteDto>{
    constructor() {
        super(x => x.idCliente.toString());
        Dispatcher
            .onfunction(CustomersActions.getCliente, result => result && this.updateOrAdd(result))
            .onfunction(CustomersActions.submitFilter, ({ result }) => this.setAll(result))
            .onfunction(CustomersActions.add, result => this.updateOrAdd(result))
            .onfunction(CustomersActions.update, result => this.updateOrAdd(result))
            .onfunction(CustomersActions.delete, result => {
                if (result.deleteOk)
                    this.delete(result.customerId.toString())
            })
    }
    use = (id: number | null) => this.useWithAction(() => id && CustomersActions.getCliente(id), id?.toString() ?? null);
}

export const PageStore = new CustomersPageStore()
export default new CustomersStore()
